var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        "close-on-click-modal": false,
        width: "460px"
      },
      on: { close: _vm.handleClose }
    },
    [
      !_vm.uploadSuccess
        ? _c(
            "div",
            [
              _c("p", [
                _vm._v("请先"),
                _c(
                  "a",
                  {
                    staticStyle: { color: "blue" },
                    on: { click: _vm.handleExport }
                  },
                  [_vm._v("下载模板")]
                )
              ]),
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 6 } }, [
                    _vm._v("选择导入文件")
                  ]),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-form",
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              attrs: {
                                action: _vm.action,
                                "on-success": _vm.handleSuccess,
                                "on-error": _vm.handleError,
                                "on-change": _vm.handleChange,
                                "before-upload": _vm.handleBeforeUpload,
                                "file-list": _vm.fileList,
                                "auto-upload": false,
                                multiple: false,
                                headers: _vm.headers,
                                data: _vm.data,
                                accept: ".xls,.xlsx",
                                name: "file"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "trigger",
                                    size: "small",
                                    type: "primary"
                                  },
                                  slot: "trigger"
                                },
                                [_vm._v("选取文件")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip"
                                },
                                [
                                  _vm._v(
                                    "文件大小不可超过20M，支持.xls和.xlsx格式"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-col", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "注意：如重新上传，则已上传的数据将会被全部清除，请谨慎操作！"
                    )
                  ])
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "15px" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 18, offset: 6 } },
                    [
                      _c("el-form", [
                        _c(
                          "span",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.submitUpload }
                              },
                              [_vm._v("开始导入")]
                            ),
                            _c(
                              "el-button",
                              { on: { click: _vm.handleClose } },
                              [_vm._v("取 消")]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c("div", [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("Warehouse.ImportingData")) + "...")
            ]),
            _c("p", { staticStyle: { color: "red" } }, [
              _vm._v(
                _vm._s(_vm.$t("Warehouse.ThisOperationIsAnAsynchronousImport"))
              )
            ]),
            _c(
              "div",
              {
                staticStyle: { "text-align": "center" },
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "span",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleClose }
                      },
                      [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
                    ),
                    _c("el-button", { on: { click: _vm.searchResult } }, [
                      _vm._v(_vm._s(_vm.$t("Warehouse.ViewResults")))
                    ])
                  ],
                  1
                )
              ]
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }